module.exports = __webpack_public_path__ + "media/images/city_img/s_3-1f480f160fb5bc35eb7426f1bd9dbc1a.png";